import { MutableRefObject, useRef } from "react";

interface Output {
  blockScroll: () => void;
  allowScroll: () => void;
}

// Source: https://gist.github.com/reecelucas/2f510e6b8504008deaaa52732202d2da
const useScrollBlock = (): Output => {
  const isScrollBlocked: MutableRefObject<boolean> = useRef();

  const blockScroll = (): void => {
    const { body, documentElement: html } = window.document;

    if (!body?.style || isScrollBlocked.current) return;

    const scrollBarWidth = window.innerWidth - html.clientWidth;
    const bodyPaddingRight =
      parseInt(window.getComputedStyle(body).getPropertyValue("padding-right"), 10) || 0;

    /**
     * 1. Fixes a bug in iOS and desktop Safari whereby setting
     *    `overflow: hidden` on the html/body does not prevent scrolling.
     * 2. Fixes a bug in desktop Safari where `overflowY` does not prevent
     *    scroll if an `overflow-x` style is also applied to the body.
     */
    html.style.position = "relative"; /* [1] */
    html.style.overflow = "hidden"; /* [2] */
    body.style.position = "relative"; /* [1] */
    body.style.overflow = "hidden"; /* [2] */
    body.style.paddingRight = `${bodyPaddingRight + scrollBarWidth}px`;

    isScrollBlocked.current = true;
  };

  const allowScroll = (): void => {
    const { body, documentElement: html } = window.document;

    if (!body?.style || !isScrollBlocked.current) return;

    html.style.position = "";
    html.style.overflow = "";
    body.style.position = "";
    body.style.overflow = "";
    body.style.paddingRight = "";

    isScrollBlocked.current = false;
  };

  return {
    allowScroll,
    blockScroll,
  };
};

export default useScrollBlock;
